<div class="container padding-top-10 padding-bottom-10">
  <div class="flash-message-container">
    <flash-message></flash-message>
  </div>

  <div class="col-xs-12" ng-show="ocorrencia.id" id="print-ocorrencia">
    <div class="row">
      <div class="col-xs-12">
        <div class="panel panel-default no-margin">
          <div class="panel-heading">
            <h4 class="panel-title">Ocorrência de Máquina</h4>
          </div>
          <div class="panel-body">
            <div class="row">
              <div class="col-xs-12">
                <p><strong>Código:</strong> {{::ocorrencia.id}}</p>
                <p><strong>Tipo:</strong> {{::ocorrencia.tipo.descricao}}</p>
                <p><strong>Safra:</strong> {{::ocorrencia.safra.descricao}}</p>
                <p ng-show="ocorrencia.usuario"><strong>Aberto por:</strong> {{::ocorrencia.usuario.nome | capitalize}} em {{::ocorrencia.createdAt | date:'dd/MM/yyyy \'às\' HH:mm'}}</p>
                <p><strong>Data:</strong> {{::ocorrencia.data | date:'dd/MM/yyyy'}}</p>
                <p><strong>Data Prazo:</strong> {{::ocorrencia.dataPrazo | date:'dd/MM/yyyy'}}</p>
                <p ng-if="ocorrencia.dataPrazoChecagem"><strong>Prazo Checagem:</strong> {{::ocorrencia.dataPrazoChecagem | date:'dd/MM/yyyy'}}</p>
                <p><strong>Máquina:</strong> {{::ocorrencia.maquina.descricao}}</p>
                <span ng-hide="ocorrencia.maquina.grupo.descricao === 'IMPLEMENTOS'">
                  <p><strong>{{tiposControleMaquina[ocorrencia.maquina.tipo_controle_manutencao] || ''}}:</strong> {{::(ocorrencia.hodometro)}}</p>
                  <p ><strong>Máquina Parada:</strong> {{ocorrencia.maquinaParada ? 'Sim' : 'Não'}}</p>
                </span>
                <p><strong>Operador:</strong> {{::ocorrencia.operador.nome | capitalize}}</p>
                <p ng-if="ocorrencia.dataFechado"><strong>Negligência:</strong> {{::ocorrencia.negligencia ? 'Sim' : 'Não'}}</p>
                <p>
                  <strong>Status:</strong> {{::ocorrencia.status.descricao}}
                  <span ng-if="ocorrencia.status.id == 'fechado'">em {{::ocorrencia.dataFechado | date:'dd/MM/yyyy'}} {{::ocorrencia.horaFechado | date:'HH:mm'}}</span>
                  <span ng-if="ocorrencia.status.id == 'checado'">em {{::ocorrencia.dataChecagem | date:'dd/MM/yyyy'}}</span>
                </p>
                <p ng-if="ocorrencia.status.id == 'fechado'">
                  <strong>Fechado por:</strong> {{::ocorrencia.usuarioFechamento.nome}} em {{::ocorrencia.dataFechamento | date:'dd/MM/yyyy'}}
                </p>
                <p><strong>Relato:</strong> {{::ocorrencia.relato}}</p>
                <p ng-if="ocorrencia.localizacao.latitude && ocorrencia.localizacao.longitude">
                  <strong>Localização:</strong>
                  <a href="https://www.google.com.br/maps/place/{{::ocorrencia.localizacao.latitude}},{{::ocorrencia.localizacao.longitude}}" target="_blank">
                    Google Maps <i class="fa fa-external-link" aria-hidden="true"></i>
                  </a>
                </p>
                <p>
                  <strong>Itens de Manutenção:</strong>
                  {{::ocorrencia.itensManutencao | getTextItems | capitalize}}
                  <small ng-if="!ocorrencia.itensManutencao.length">Nenhum item</small>
                </p>
              </div>

              <div class="col-xs-12">
                <div class="col-lg-3 col-md-4 col-xs-6" ng-if="ocorrencia.imagens" ng-repeat="imagem in ocorrencia.imagens track by $index">
                  <img ng-src="{{imagem.thumb}}" class="thumbnail img-responsive center-block btn" ng-click="openImageLightBox(ocorrencia.imagens, $index)">
                </div>
              </div>

              <div class="col-xs-12">
                <p>
                  <strong>Comentários:</strong>
                  <small ng-if="!ocorrencia.comentarios.length">Nenhum comentário</small>
                </p>
                <ul ng-if="ocorrencia.comentarios.length" class="list-unstyled only-print">
                  <li ng-repeat="comentario in ocorrencia.comentarios | orderBy: '-created_at' track by comentario.id">
                    <p><strong>{{comentario.created_at | date: 'dd/MM \'às\' HH:mm'}}, {{::comentario.usuario.nome | capitalize}}</strong>: {{comentario.comentario}}</p>
                  </li>
                </ul>

                <uib-accordion close-others="false" class="hidden-print">
                  <uib-accordion-group class="panel-default" is-open="comentario.open" ng-repeat="comentario in ocorrencia.comentarios | orderBy: '-created_at' track by comentario.id">
                    <uib-accordion-heading>
                      <h4 class="panel-title">
                        {{comentario.created_at | date: 'dd/MM \'às\' HH:mm'}}, {{::comentario.usuario.nome | capitalize}} disse...
                        <i class="pull-right glyphicon" ng-class="{'glyphicon-chevron-up': comentario.open, 'glyphicon-chevron-down': !comentario.open}"></i>
                      </h4>
                    </uib-accordion-heading>

                    <p>{{comentario.comentario}}</p>
                    <div class="col-xs-12">
                      <div class="col-lg-3 col-md-4 col-xs-6" ng-if="comentario.imagens" ng-repeat="imagem in comentario.imagens track by $index">
                        <img ng-src="{{imagem.thumb}}" class="thumbnail img-responsive center-block btn" ng-click="openImageLightBox(comentario.imagens, $index)">
                      </div>
                    </div>

                    <div class="text-right" ng-if="permissions.maquina.canManage">
                      <span class="text-danger pointer" ng-click="deleteComment(comentario.id)"><i class="glyphicon glyphicon-trash" aria-hidden="true" ></i>Excluir</span>
                    </div>
                  </uib-accordion-group>
                </uib-accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden-print row pull-right padding-top-10" ng-include="'views/ocorrencias_maquinas/_show_buttons.html'"></div>
  </div>
</div>
